var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 6.24994H21.25V4.9999C21.25 3.62113 20.1288 2.49988 18.75 2.49988H11.25C9.87123 2.49988 8.74998 3.62107 8.74998 4.9999V6.24988H2.50002C1.12119 6.24994 0 7.37113 0 8.74991V12.4999C0 13.8787 1.12119 14.9999 2.50002 14.9999H12.5V14.3749C12.5 14.0294 12.7796 13.7499 13.1251 13.7499H16.8751C17.2205 13.7499 17.5001 14.0294 17.5001 14.3749V14.9999H27.5001C28.8788 14.9999 30 13.8787 30 12.4999V8.74991C30 7.37113 28.8788 6.24994 27.5 6.24994ZM18.75 6.24994H11.25V4.9999H18.75V6.24994Z",
    fill: "#FFBB38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6533 15.6743C29.4403 15.5687 29.1858 15.5931 28.9978 15.7359C28.5534 16.0723 28.0358 16.2498 27.4999 16.2498H17.5V18.1249C17.5 18.4703 17.2205 18.7499 16.875 18.7499H13.125C12.7795 18.7499 12.5 18.4703 12.5 18.1249V16.2498H2.50002C1.96412 16.2498 1.44656 16.0723 1.00219 15.7359C0.813574 15.5919 0.559687 15.5675 0.346641 15.6743C0.134297 15.7799 0 15.9965 0 16.234V24.9999C0 26.3787 1.12119 27.4999 2.50002 27.4999H27.5C28.8788 27.4999 30.0001 26.3787 30.0001 24.9999V16.234C30 15.9965 29.8657 15.7799 29.6533 15.6743Z",
    fill: "#FFBB38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.9d363607c07d775ed75b35f7604d0687.svg";
export { ForwardRef as ReactComponent };